<template>
  <div class="">
    <div class="bg-white rounded-2xl border shadow-xl p-8 lg:p-10 max-w-lg">
      <form @submit.prevent="createRecord()">
        <div class="flex flex-col items-center space-y-2 lg:space-y-4">
          <template v-if="screen == 'start'">
            <h1 class="font-bold lg:text-2xl text-gray-700 text-center">Записаться на осмотр</h1>
            <p class="text-sm text-gray-500 text-center pb-2">Выберите удобный день и время</p>

            <input type="text" required v-model="record.fio" placeholder="Ваше имя" class="border-2 rounded-lg w-full text-sm lg:text-base px-2 py-2 " />
            <input type="text" required @keypress="checkFormat" v-model="record.phone" placeholder="Номер телефона" class="border-2 rounded-lg w-full text-sm lg:text-base px-2 py-2 " />
            <input type="date" :min="$dayjs().format('YYYY-MM-DD')" v-model="record.date" placeholder="Выберите дату" class="border-2 rounded-lg w-full text-sm lg:text-base px-2 py-2 " />

            <template v-if="record.date">
              <select class="border-2 rounded-lg w-full text-sm lg:text-base px-2 py-2 " v-model="record.serviceIndex">
                <option value="-1">Выберите услугу</option>
                <option :value="index" v-for="(s, index) of services" :key="index">{{ s.title }} (🕞 {{ s.time }} мин.)</option>
              </select>
            </template>

            <template v-if="record.serviceIndex != -1 && record.date && slots.length > 0">
              <select class="border-2 rounded-lg w-full text-sm lg:text-base px-2 py-2 " v-model="record.time">
                <option value="-1">Выберите время</option>
                <option v-for="(slot, index) of slots" :key="index" :value="slot">{{ slot.start | humantime }}</option>
              </select>
            </template>

            <template v-if="record.serviceIndex != -1 && record.date && slots.length == 0 && busy == false">
              <span class="my-2">
                На эту дату свободных мест нет
              </span>
            </template>

            <button class="bg-green-500 text-white rounded-md font-semibold px-4 py-3 w-full" v-if="readyToSend">
              Записаться
            </button>
          </template>

          <template v-if="screen == 'success'">
            <div class="bg-white p-6  md:mx-auto">
              <svg viewBox="0 0 24 24" class="text-green-600 w-16 h-16 mx-auto my-6">
                <path
                  fill="currentColor"
                  d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
                ></path>
              </svg>
              <div class="text-center">
                <h3 class="md:text-2xl text-base text-gray-900 font-semibold text-center">{{ record.date }} в {{ record.time.start | humantime }}</h3>
                <p class="text-gray-600 my-2">Менеджер свяжется с вами, чтобы подвердить вашу запись.</p>
              </div>
            </div>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
var auth = "?id=609542b0803f0c4dd431e855&domain=test";
var api = "http://localhost:5000/api/public/v1";

export default {
  name: "App",
  data() {
    return {
      record: {
        serviceIndex: -1,
        fio: "",
        date: "",
        time: -1,
        phone: "",
        opticId: "",
      },
      services: [],
      slots: [],
      busy: false,
      screen: "start",
      appId: "",
    };
  },
  components: {},
  watch: {
    "record.date": function(newone, old) {
      this.loadTimeSlots();
    },
    "record.serviceIndex": function(newone, old) {
      this.loadTimeSlots();
    },
  },
  mounted() {
    // set app id
    //document.getElementById('mnkl-widget').getAttribute('data-id');
    this.appId = this.$deptId;
    this.record.opticId = this.appId;

    this.loadServices();
    console.log(process.env.VUE_APP_BACKEND_URL);
  },
  methods: {
    checkFormat(evt) {
      // formatting phone
      const keysAllowed = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "+"];
      const keyPressed = evt.key;

      if (!keysAllowed.includes(keyPressed) || evt.target.value.length == 12) {
        evt.preventDefault();
      }
    },
    async createRecord() {
      let { data } = await this.$axios.post("/create-record", this.record);
      this.screen = "success";
    },
    async loadServices() {
      let { data } = await this.$axios.get("/services?id=" + this.appId);
      this.services = data;
    },
    async loadTimeSlots() {
      // continue only if service id and date selected
      if (this.record.serviceIndex == -1 || !this.record.date) {
        return;
      }

      this.busy = true;
      console.log("load timeslots for " + this.record.date);

      let { data } = await this.$axios.get("/timeslots/" + this.appId + "/" + this.record.date + "/" + this.record.serviceIndex);
      // merge to one array with status 0
      let slots = data;

      slots = slots.filter((item) => item.status == 0);

      let filteredSlots = [];

      slots.map((item) => {
        if (filteredSlots.findIndex((r) => r.start == item.start) == -1) {
          filteredSlots.push(item);
        }
      });

      this.slots = filteredSlots.sort((a, b) => {
        return a.start - b.start;
      });

      this.busy = false;
    },
  },
  computed: {
    readyToSend() {
      return this.record.serviceIndex != -1 && this.record.date && this.record.time != -1 && this.busy == false;
    },
  },
};
</script>

<style></style>
